export const ROUTE_PATH =
  '/reconciliation-archive-refunds/store[eq]=:store_id&archive[eq]=:archive_eq';

export const FEATURE_NAME = 'reconciliationArchiveRefundsPage';
